import React, { useContext } from 'react';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import Switch from '@material-ui/core/Switch';
import IconButton from '@material-ui/core/IconButton';

import useTranslations from '../../hooks/useTranslations';
import SlimLineCard from '../containers/cards/SlimLineCard';
import styled from 'styled-components/macro';
import ActionsTooltip from '../ActionsTooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import Tooltip from '@material-ui/core/Tooltip';
import AutomationWizardEngine from '../automations/engine/AutomationWizardEngine';
import Select from '../engine/SelectEngine';
import { AdditionalDropdown } from '../automations/view/AutomationsActionsView';
import { Actions } from '../automations/engine/AutomationsActionsEngine';
import LabelImportantIcon from '@material-ui/icons/LabelImportant';
import { Draggable } from 'react-beautiful-dnd';
import { AutomationsContex } from '../engine/FormBuilderAutomationsEngine';
import DeleteDialog from '../../internal-components/GeneralDialog';
import Animation from '../Animation';
import FileCopyIcon from '@material-ui/icons/FileCopy';

const cardCSS = `

  margin-bottom: 1rem;

  h2 {
    margin: 0;
    margin-left: 0.8rem;
    font-size: 18px;
  }

  svg {
    color: #c8c8c8;
  }

`;

const ActionLabel = styled.span`
  margin-right: 5rem;
  margin-left: auto;
`;

const FormBuilderAutomationCardView = props => {
  const t = useTranslations();
  const { filter, onAutomationDuplicate } = useContext(AutomationsContex);
  return (
    <>
      <Animation
        in={!props.isInDeleteSequence}
        onExited={props.onDelete}
        type="collapse"
      >
        <Draggable draggableId={props.id} index={props.position}>
          {provided => (
            <ActionsTooltip
              leaveDelay={0}
              buttons={[
                <Tooltip title="Edit">
                  <IconButton size="small" onClick={props.onEdit}>
                    <CreateIcon />
                  </IconButton>
                </Tooltip>,
                <Tooltip
                  title="Duplicate"
                  onClick={() => onAutomationDuplicate(props.id)}
                >
                  <IconButton size="small">
                    <FileCopyIcon />
                  </IconButton>
                </Tooltip>,
                <Tooltip
                  title="Delete"
                  onClick={() => props.setIsDeleteDialogOpen(true)}
                >
                  <IconButton size="small">
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              ]}
            >
              <SlimLineCard
                $rounded
                $css={cardCSS}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...(filter ? {} : provided.dragHandleProps)}
              >
                <DragIndicatorIcon style={{ opacity: filter ? 0.5 : 1 }} />
                <h2>{props.title}</h2>
                <ActionLabel>
                  {t(`automaions.wizard.trigger.short.${props.trigger}`)}
                </ActionLabel>
                <Switch
                  checked={props.isChecked}
                  onChange={props.onToggleSwitch}
                  color="primary"
                />
              </SlimLineCard>
            </ActionsTooltip>
          )}
        </Draggable>
      </Animation>
      <DeleteDialog
        open={props.isDeleteDialogOpen}
        title="delete_form_dialog.title"
        content="automation.delete.msg"
        variant="delete"
        handleClose={() => props.setIsDeleteDialogOpen(false)}
        handleConfirm={() => {
          props.setIsDeleteDialogOpen(false);
          props.setIsInDeleteSequence(true);
        }}
      />
    </>
  );
};

const StaticCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h2 {
    font-size: 18px;
  }

  & > svg {
    margin-left: 0.8rem;
    margin-right: -8.5rem;
    opacity: 0.3;
  }

  span {
    font-weight: 500;
  }
`;

const staticCardCSS = `& > div {margin-right: 0.8rem !important;}`;

export const StaticFormBuilderAutomationCardView = props => {
  const t = useTranslations();
  return (
    // <StaticCard>
    //   <LabelImportantIcon />
    //   <h2>
    //     {props.title} {t('automaions.wizard.setStatus')}
    //   </h2>
    //   {/* <span>{t('automaions.wizard.setStatus')}</span> */}
    //   <ActionLabel>
    //     <AdditionalDropdown
    //       actionType={Actions.STATUS_CHANGE}
    //       update={props.onStaticTriggerChange}
    //       {...props.automationData.rule.action}
    //     />
    //   </ActionLabel>
    //   <Switch checked onChange={() => {}} color="primary" disabled />
    // </StaticCard>
    <SlimLineCard $rounded $noBorder $css={staticCardCSS}>
      {t('automaions.wizard.static.text.new')}
      <AdditionalDropdown
        variant="inline"
        actionType={Actions.STATUS_CHANGE}
        update={props.onStaticTriggerChange}
        noEmail
        {...props.automationData.rule.action}
      />
      {t('automaions.wizard.static.text.postfix')}
    </SlimLineCard>
  );
};

export default FormBuilderAutomationCardView;
